<template>
    <div class="container">
        <h1>Liste des Types de Tissus</h1>
        <p class="text-info"><i class="bi bi-info-circle"></i> Cette page affichera la liste des types de tissus
            disponibles pour selection lors de l'enregistrement d'un
            tissu founi par le client.</p>

        <hr />
        <card>
            <template #body>
                <h3>Ajouter un nouveau type?</h3>
                <TissuTypeForm @saved="getTissuTypes" />
            </template>
        </card>
        <hr />
        <h3>Types de tissus existants</h3>
        <div class="table-responsive">
            <card>
                <template #body>
                    <table class="table table-striped" v-if="tissuTypes.length">
                        <thead>
                            <tr>
                                <th>#</th>
                                <th>Libellé</th>
                                <th>Description</th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(type, index) in tissuTypes" :key="type.id">
                                <td>{{ index + 1 }}</td>
                                <td>{{ type.label }}</td>
                                <td>{{ type.description }}</td>
                                <td>
                                    <i class="bi bi-trash text-danger" role="button"
                                        @click="deleteTissuType(type.id)"></i>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <div v-else class="d-flex justify-content-center align-items-center flex-column">
                        <p>Aucun type de tissu n'a encore été ajouté.</p>
                        <p><i class="bi bi-box-seam fs-1 text-warning"></i></p>
                    </div>
                </template>
            </card>
        </div>

    </div>
</template>

<script>
import TissuTypeForm from '@/components/forms/TissuTypeForm.vue';
import Card from '@/components/elements/Card.vue';

export default {
    name: 'TissuTypeList',
    components: {
        TissuTypeForm,
        Card
    },
    data() {
        return {
            tissuTypes: [],
            url: "/type_tissus"
        };
    },
    methods: {
        getTissuTypes() {
            this.$api.get(this.url)
                .then(response => {
                    this.tissuTypes = response.data.data;
                })
                .catch(error => {
                    console.error('There was an error fetching the tissu types!', error);
                });
        },
        deleteTissuType(id) {
            if (!confirm('Êtes-vous sûr de vouloir supprimer ce type de tissu ?')) {
                return;
            }
            this.$api.delete(`${this.url}/${id}`)
                .then(() => {
                    this.getTissuTypes();
                    // this.tissuTypes = this.tissuTypes.filter(type => type.id !== id);
                })
                .catch(error => {
                    console.error('There was an error deleting the tissu type!', error);
                });
        }
    },

    created() {
        this.getTissuTypes();
    }
};
</script>